import type { ReactNode } from "react";

/**
 * Un testo del catalogo con il segnaposto «{link}» e, al suo posto, il collegamento (per esempio a «Ruoli e permessi»): la
 * frase resta una sola nel catalogo, in ogni lingua. Un testo senza il segnaposto resta com'è.
 */
export function withLink(text: string, link: ReactNode): ReactNode {
  const parts = text.split("{link}");
  if (parts.length !== 2) return text;
  return (
    <>
      {parts[0]}
      {link}
      {parts[1]}
    </>
  );
}
